var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#424B53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1885 41.3734C47.1959 40.3734 44.7921 38.9141 43.6259 38.326C42.1071 37.5611 41.9821 37.4986 40.7883 38.3854C39.992 38.9772 39.4626 39.506 38.5307 39.3072C37.5988 39.1085 35.5738 37.9879 33.8006 36.2205C32.0275 34.4531 30.8418 32.3694 30.6424 31.4407C30.443 30.512 30.9806 29.9889 31.5668 29.1908C32.3931 28.0658 32.3306 27.8783 31.6243 26.3597C31.0737 25.1785 29.5718 22.7973 28.568 21.8099C27.4942 20.7493 27.4942 20.9368 26.8023 21.2243C26.239 21.4612 25.6986 21.7493 25.1879 22.0848C24.1879 22.7492 23.6329 23.301 23.2447 24.1304C22.8566 24.9597 22.6822 26.904 24.6866 30.5451C26.6911 34.1862 28.0974 36.048 31.0081 38.9504C33.9187 41.8527 36.1569 43.4133 39.4289 45.2482C43.4765 47.515 45.029 47.0731 45.8609 46.6857C46.6928 46.2982 47.2472 45.7482 47.9128 44.7482C48.2493 44.2384 48.538 43.6986 48.7754 43.1358C49.0635 42.4465 49.251 42.4465 48.1885 41.3734Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5a5c222776c1b337aeeff33b7e123967.svg";
export { ForwardRef as ReactComponent };